export default "__VITE_ASSET__Bb4znJV7__"